<div class="recents-wrapper">
  <h4 class="recents-toggle" [class.no-margin-bottom]="inHeader">
    <span (click)="toggleShow = !!(!toggleShow && inHeader)">
      Recently viewed
      <ng-container *ngIf="inHeader">
        <i
          class="fas fa-angle-down"
          [ngClass]="toggleShow ? 'fa-angle-down' : 'fa-angle-right'"
        ></i>
      </ng-container>
    </span>
  </h4>
  <ul *ngIf="recents && (toggleShow || !inHeader)" [class.inHeader]="inHeader">
    <li *ngFor="let recent of recents | recentFilterPipe: showMore">
      {{ recent.type }}
      <a [href]="recent.url">{{ recent.title }}</a>
    </li>
    <br />
    <p class="showMore" (click)="showMore = !showMore">
      {{ showMore ? 'Show less' : 'Show more' }}
    </p>
  </ul>
</div>
